module.exports = __webpack_public_path__ + "img/wanna play 2023.f6226c22.webp";